export default __webpack_public_path__ + "static/media/the-how-photographer.060cbbf9.jpg";